import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

const ExcitedIcon = (props: IconProps) => {
  return (
    <Icon
      fill="none"
      viewBox="0 0 72 72"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fill="#FFCC4D" d="M72 36a36 36 0 1 1-72 0 36 36 0 0 1 72 0Z" />
      <path
        fill="#664500"
        d="M36 42c-7.2 0-12-.8-18-2-1.4-.3-4 0-4 4 0 8 9.2 18 22 18s22-10 22-18c0-4-2.6-4.3-4-4-6 1.2-10.8 2-18 2Z"
      />
      <path fill="#fff" d="M18 44s6 2 18 2 18-2 18-2-4 8-18 8-18-8-18-8Z" />
      <path
        fill="#E95F28"
        d="m31.4 8.8-9.1 1.6L17.6 2a2.5 2.5 0 0 0-4.7.8l-1.5 9.6-9 1.6a2.5 2.5 0 0 0-.7 4.8l8.2 3.8-1.5 9.6a2.5 2.5 0 0 0 4.2 2.2l7-7.1 9 4.3A2.5 2.5 0 0 0 32 28l-4.7-8.5 6.4-6.5a2.5 2.5 0 0 0-2.2-4.2Zm9.2 0 9.1 1.6L54.4 2a2.5 2.5 0 0 1 4.7.8l1.4 9.6 9.1 1.6a2.5 2.5 0 0 1 .7 4.8L62 22.5l1.5 9.6a2.5 2.5 0 0 1-4.2 2.2l-7-7.1-9 4.3A2.5 2.5 0 0 1 40 28l4.6-8.5-6.3-6.5a2.5 2.5 0 0 1 2.2-4.2Z"
      />
    </Icon>
  );
};

export default ExcitedIcon;
